/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-12.
 * This component will be used per each page.
 */
import React from 'react';
import { RefreshIndicator, Divider, FloatingActionButton } from 'material-ui';
import ContentAdd from 'material-ui/svg-icons/content/add';
import Pagination from '../widgets/pagination';
import { REFRESH_INDICATOR, FLOATING_BUTTON_STYLE } from '../../styles';

const SubHeader = ({ showRefresh, title, paginationConfig, onPressHeaderButton, showAddButton }) => {
    const showPagination = paginationConfig && paginationConfig.numPages && paginationConfig.numPages > 0;
    return (
        <div>
            {
                showRefresh &&
                <div style={REFRESH_INDICATOR}>
                    <RefreshIndicator size={40} left={10} top={70} status="loading" />
                </div>
            }
            <div className="pagination-container">
                <div className="col-lg-8 col-md-7 col-sm-7 col-xs-12">
                    <h1 className="main-title wrapped-text">{title}</h1>
                </div>
                <div
                    className="col-lg-4 col-md-5 col-sm-5 col-xs-12"

                >
                    <div className="">
                        {showPagination === true && <Pagination {...paginationConfig} />}
                    </div>
                </div>
                <Divider style={{ marginTop: 10, marginBottom: 10 }} />
            </div>
            {
                showAddButton &&
                <FloatingActionButton
                    className="button-add-new"
                    style={FLOATING_BUTTON_STYLE}
                    onTouchTap={onPressHeaderButton}
                >
                    <ContentAdd />
                </FloatingActionButton>
            }
        </div>
    );
};

export default SubHeader;



// WEBPACK FOOTER //
// ./components/layout/subheader.js